const DEFAULT_FORMAT_OPTIONS = {
    style: "currency",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
};
/**
 * Formats a number as a currency
 * @param value The value to format
 * @param options The options to pass to the formatter
 * @returns The formatted currency
 */
export function formatCurrency(value, options = {}) {
    const formatter = new Intl.NumberFormat("en-US", {
        ...DEFAULT_FORMAT_OPTIONS,
        ...options,
    });
    return formatter.format(value);
}
/**
 * Formats a number as a USD currency
 * @param value The value to format
 * @returns The formatted currency
 */
export function formatUsd(value) {
    return formatCurrency(value, { currency: "USD" });
}
//# sourceMappingURL=currency.js.map